import { render, staticRenderFns } from "./New.vue?vue&type=template&id=55a95299&scoped=true"
import script from "./New.vue?vue&type=script&lang=js"
export * from "./New.vue?vue&type=script&lang=js"
import style0 from "./New.vue?vue&type=style&index=0&id=55a95299&prod&scoped=true&lang=css"
import style1 from "./New.vue?vue&type=style&index=1&id=55a95299&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55a95299",
  null
  
)

export default component.exports